export default __webpack_public_path__ + "static/media/op_share.fffc7796.svg";